import React, { Component } from 'react'
import { Header } from './Header'
import { Footer } from './Footer'
import { Card, Pagination, Row, Col, Container } from 'react-bootstrap'

// Imports de imágenes
import img1 from '../Diagnostico/img1.jpg'
import img2 from '../Diagnostico/img2.jpg'
import img3 from '../Diagnostico/img3.jpg'
import img4 from '../Diagnostico/img4.jpg'
import img5 from '../Diagnostico/img5.jpg'
import img6 from '../Diagnostico/img6.jpg'
import img7 from '../Diagnostico/img7.jpg'
import img19 from '../Diagnostico/img19.jpg'
import img20 from '../Diagnostico/img20.jpg'
import img21 from '../Diagnostico/img21.jpg'
import img22 from '../Diagnostico/img22.jpg'
import img23 from '../Diagnostico/img23.jpg'
import img25 from '../Diagnostico/img25.jpg'

export class FeDiagnosis2 extends Component {
    render() {
        const diagnosticItems = [
            { img: img1, title: "Digital sphygmomanometer" },
            { img: img4, title: "Mercury-free digital sphygmomanometer" },
            { img: img7, title: "Sphygmomanometers" },
            { img: img22, title: "Double head stainless steel stethoscope" },
            { img: img2, title: "Digital sphygmomanometer" },
            { img: img5, title: "Mercury-free sphygmomanometer" },
            { img: img21, title: "Stethoscope" },
            { img: img23, title: "Deluxe stethoscope" },
            { img: img3, title: "Digital sphygmomanometer" },
            { img: img6, title: "Tabletop mercury-free sphygmomanometer" },
            { img: img19, title: "Single and double head stethoscope" },
            { img: img20, title: "Rappaport stethoscopes" },
            { img: img25, title: "Miscellaneous" }
        ];

        return (
            <div>
                <Header />
                <Container fluid className="px-5">
                    <br />
                    <Row>
                        <Col className="text-center">
                            <h1>Diagnosis</h1>
                        </Col>
                    </Row>
                    <br />

                    <Pagination className="justify-content-center" size="lg">
                        <Pagination.Item href="/en/FeDiagnosis">{1}</Pagination.Item>
                        <Pagination.Item active>{2}</Pagination.Item>
                    </Pagination>

                    {/* Sistema de rejilla para mantener orden y estética */}
                    <Row xs={1} md={2} lg={4} className="g-4 text-center">
                        {diagnosticItems.map((item, idx) => (
                            <Col key={idx}>
                                <Card className="h-100 shadow-sm border-0">
                                    <Card.Body className="p-3">
                                        <Card.Img 
                                            variant="top" 
                                            src={item.img} 
                                            style={{ objectFit: 'contain', height: '220px', padding: '10px' }} 
                                        />
                                    </Card.Body>
                                    <Card.Footer className="bg-white border-0">
                                        <Card.Title style={{ fontSize: '1.1rem' }}>{item.title}</Card.Title>
                                    </Card.Footer>
                                </Card>
                            </Col>
                        ))}
                    </Row>

                    <br />
                    <Pagination className="justify-content-center" size="lg">
                        <Pagination.Item href="/en/FeDiagnosis">{1}</Pagination.Item>
                        <Pagination.Item active>{2}</Pagination.Item>
                    </Pagination>
                    <br />
                </Container>
                <Footer />
            </div>
        )
    }
}